export default 'vHTML5Player_v2.0.0';



// WEBPACK FOOTER //
// ./version.js